// Celebrity dataset for Celebrity Smash - all portraits are gradient/initial placeholders
// styled to fit the retro-editorial neon look. No external image dependencies required.

export const CATEGORIES = ["Movies", "Music", "Sports", "Historical", "Business & Tech"];

// Palette pairs for placeholder portraits [from, to, accent]
const PALETTES = [
  ["#FF107A", "#7A0F3E", "#FFD700"],
  ["#A855F7", "#3B1663", "#00E5FF"],
  ["#00E5FF", "#0C4A6E", "#FF107A"],
  ["#FFD700", "#7A5F00", "#FF107A"],
  ["#FF6B35", "#5A1B00", "#FDFBF7"],
  ["#22D3EE", "#164E63", "#A855F7"],
  ["#F472B6", "#831843", "#FDFBF7"],
  ["#84CC16", "#365314", "#FDFBF7"],
];

let idc = 1;
const make = (name, category, era, descriptor, traits, paletteIdx = null) => {
  const palette = PALETTES[paletteIdx ?? (idc % PALETTES.length)];
  return {
    id: `c${idc++}`,
    name,
    category,
    era,
    descriptor,
    traits,
    palette,
    active: true,
  };
};

export const CELEBRITIES = [
  // Movies
  make("Keanu Reeves", "Movies", "Modern", "Reluctant action icon with monk-like calm.", ["kind", "authentic", "mysterious"], 1),
  make("Ryan Gosling", "Movies", "Modern", "Cool-jazz charisma in a leather jacket.", ["charismatic", "creative", "attractive"], 0),
  make("Robert Downey Jr.", "Movies", "Modern", "Sharp-tongued comeback king of cinema.", ["witty", "confident", "creative"], 4),
  make("Sam Rockwell", "Movies", "Modern", "Character actor who steals every scene.", ["quirky", "creative", "underrated"], 5),
  make("Zendaya", "Movies", "Modern", "Gen-Z powerhouse with red-carpet gravity.", ["stylish", "confident", "cultural-impact"], 6),
  make("Florence Pugh", "Movies", "Modern", "Fearless, magnetic, unmistakably present.", ["emotional", "authentic", "adventurous"], 0),
  make("Cate Blanchett", "Movies", "Modern", "Regal shape-shifter of every role.", ["intelligent", "elegant", "values"], 2),
  make("Natalie Portman", "Movies", "Modern", "Harvard-smart with a quiet fire.", ["intelligent", "kind", "values"], 3),

  // Music
  make("David Bowie", "Music", "Retro", "Cosmic chameleon of rock and art.", ["creative", "mysterious", "cultural-impact"], 1),
  make("Prince", "Music", "Retro", "Purple genius of funk and desire.", ["creative", "charismatic", "mysterious"], 1),
  make("Elvis Presley", "Music", "Retro", "Original king who shook the world.", ["charismatic", "cultural-impact", "confident"], 4),
  make("John Lennon", "Music", "Retro", "Rebel poet who wanted peace.", ["creative", "values", "authentic"], 3),
  make("Freddie Mercury", "Music", "Retro", "Operatic voice of stadium magic.", ["charismatic", "creative", "confident"], 0),
  make("Lady Gaga", "Music", "Modern", "Pop's theatrical, kind provocateur.", ["creative", "kind", "cultural-impact"], 6),
  make("Beyoncé", "Music", "Modern", "Precision, power, cultural gravity.", ["confident", "creative", "cultural-impact"], 4),
  make("Dolly Parton", "Music", "Retro", "Rhinestone saint of songwriting.", ["kind", "authentic", "values"], 6),

  // Sports
  make("Serena Williams", "Sports", "Modern", "Unrelenting queen of the court.", ["confident", "values", "cultural-impact"], 0),
  make("Simone Biles", "Sports", "Modern", "Gravity-defying gymnast, honest voice.", ["authentic", "values", "confident"], 6),
  make("Muhammad Ali", "Sports", "Retro", "Poet, fighter, principle in motion.", ["confident", "values", "cultural-impact"], 4),
  make("Michael Jordan", "Sports", "Retro", "Competitive fire in human form.", ["confident", "charismatic", "cultural-impact"], 3),
  make("Tom Brady", "Sports", "Modern", "Calculating quarterback dynasty.", ["confident", "intelligent", "cultural-impact"], 2),
  make("Megan Rapinoe", "Sports", "Modern", "Fearless captain with a sharp voice.", ["authentic", "values", "confident"], 6),

  // Historical
  make("Joan of Arc", "Historical", "Historical", "Teenage warrior-saint of France.", ["values", "confident", "mysterious"], 3),
  make("Camille Claudel", "Historical", "Historical", "Sculptor of aching beauty.", ["creative", "emotional", "authentic"], 1),
  make("Frida Kahlo", "Historical", "Historical", "Pain and color woven into legend.", ["creative", "authentic", "cultural-impact"], 0),
  make("Cleopatra", "Historical", "Historical", "Strategist queen of two empires.", ["intelligent", "charismatic", "mysterious"], 4),

  // Business & Tech
  make("Leonardo da Vinci", "Business & Tech", "Historical", "Original polymath. Codex, curiosity, canvas.", ["creative", "intelligent", "mysterious"], 5),
  make("Nikola Tesla", "Business & Tech", "Historical", "Electric prophet ahead of his century.", ["creative", "intelligent", "mysterious"], 2),
  make("Steve Jobs", "Business & Tech", "Retro", "Obsessive designer of desire.", ["creative", "confident", "cultural-impact"], 3),
  make("Walt Disney", "Business & Tech", "Retro", "Storyteller who built imagination factories.", ["creative", "cultural-impact", "confident"], 4),
];

export const findCeleb = (id) => CELEBRITIES.find((c) => c.id === id);
